import { useI18n } from '../i18n'
import { usePacer } from '../lib/pacer'
import { useSession } from '../store/session'

export function Header() {
  const { t, locale, setLocale } = useI18n()
  const screen = useSession((s) => s.screen)
  const { active, exhaling } = usePacer()
  const [a, b, c] = t.logo

  return (
    <header>
      <div className="logo">
        {a}
        <em>{b}</em>
        {c}
      </div>
      {active ? (
        <div id="hdrPacer" style={{ display: 'flex' }}>
          <div className={'pacer ' + (exhaling ? 'out' : 'in')} />
          <span>{exhaling ? t.pacer.out : t.pacer.in}</span>
        </div>
      ) : null}
      <div className="top-actions">
        {!active && <div className="step-tag">{t.step[screen]}</div>}
        <button
          className="lang-btn"
          onClick={() => setLocale(locale === 'ru' ? 'en' : 'ru')}
          aria-label="language"
        >
          {locale === 'ru' ? 'EN' : 'RU'}
        </button>
      </div>
    </header>
  )
}
